module.exports = __webpack_public_path__ + "abace7c4c10633419a04871934226bac.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Light.ttf
// module id = 406
// module chunks = 0